<template>
    <div class="cookies">


        <div class="cookies-content" v-if="lang==0">


          <h2>  Este site usa cookies </h2>
          <div class="cta">
            <p>Nós armazenamos dados temporariamente para melhorar a sua experiência de

              navegação e recomendar conteúdo do seu interesse. Ao utilizar os nossos serviços, você concorda com tal monitoramento.


            </p>
            <p>&nbsp;</p>
            <div class="footer-bts">
              <div  class="accept"><span>Aceitar </span><div class="chk"></div></div>
              <p class="mobile">&nbsp;</p>
              <span class="deny"> Rejeitar  </span>

            </div>

            <p></p>
            <p><a href="https://nossa.pt/privacy-policy.pdf" download>Política de privacidade</a></p>
            <p></p>


          </div>



        </div>
        <div class="cookies-content" v-if="lang==1">


          <h2> This website uses cookies </h2>
          <div class="cta">
            <p>We temporarily store data to improve your experience.

              navigation and recommend content of interest to you. By using our services, you consent to such monitoring.</p>
            <p>&nbsp;</p>
            <div class="footer-bts">
              <div  class="accept"><span>Accept </span><div class="chk"></div></div>
              <p class="mobile">&nbsp;</p>
              <span class="deny"> Reject  </span>

            </div>

            <p></p>
            <p><a href="https://nossa.pt/privacy-policy.pdf" download>Política de privacidade</a></p>
            <p></p>



          </div>



        </div>
      </div>

</template>

<script>



    import {TweenMax} from "gsap/TweenMax";
    import {EVENTBUS, WP} from '../../main';


    export default {

        name: 'cookies',
      props: ['actRoute', 'isMobile', 'lang'],
        data() {
            return {
                actScreen: 0

            }
        },

        created() {


        },
        mounted() {

            //EVENTBUS.$on('AAA', AAA);
            //EVENTBUS.$emit('AAA', 0);
            this.initCookies();
        },

        destroyed() {

        },

        methods: {

          initCookies(){
            const _this = this;
            $('.accept').click(function (){


              var scale = 1;
              if(window.innerWidth >= 800){
                scale = 0.8;
              }

              TweenMax.to(  '.cookies' , 0.8,{ delay: 0, y: 1000, scale:scale, force3D: true,  ease: "expo.in" , onComplete(){
                  $('.cookies').remove();
                } });

              _this.setCookie('cook3', 1, 30);

              $('.accept').addClass('vis');

            });


            $('.deny').click(function (){
              var scale = 1;
              if(window.innerWidth >= 800){
                scale = 0.8;
              }
              TweenMax.to(  '.bb' , 0.8,{ delay: 0, y: 1000,  scale:scale, force3D: true,  ease: "expo.in" , onComplete(){
                  $('.cookies').remove();
                } });


            });



            if(this.getCookie('cook3') != 1){
              var scale = 1;
              if(window.innerWidth >= 800){
                scale = 0.8;
              }
              TweenMax.to(  '.cookies' , 0.8,{ delay: 0, y: 0, scale:scale, force3D: true,  ease: "expo.in" , onComplete(){
                  $('.cookies').addClass('show');
                } });
            }else{
              $('.cookies').remove();
            }
          },


          setCookie(cname, cvalue, exdays) {
            const d = new Date();
            d.setTime(d.getTime() + (exdays*24*60*60*1000));
            let expires = "expires="+ d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
          },

          getCookie(cname) {
            let name = cname + "=";
            let decodedCookie = decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(';');
            for(let i = 0; i <ca.length; i++) {
              let c = ca[i];
              while (c.charAt(0) == ' ') {
                c = c.substring(1);
              }
              if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
              }
            }
            return "";
          }
        },
    };

</script>


// WEBPACK FOOTER //
// src/components/Modules/Cookies.vue